import { CommentsTypeEnum } from '../types'

export const commentSourceKeyMap = {
  [CommentsTypeEnum.Page]: 'commentSourcePage.pageId',
  [CommentsTypeEnum.Community]: 'commentSourceCommunityPost.communityPostId',
  [CommentsTypeEnum.LightLecture]: 'commentSourceLightLecture.lectureId',
} as const satisfies Record<CommentsTypeEnum, string>

export const toolbarGroups = [
  {
    id: 1,
    format: 'link',
    type: 'link',
  },
  {
    id: 2,
    format: 'mention',
    type: 'mention',
  },
]
